import { render, staticRenderFns } from "./tableConsultations.vue?vue&type=template&id=a95f265e&"
import script from "./tableConsultations.vue?vue&type=script&lang=js&"
export * from "./tableConsultations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports